<template>
  <div class="mettingInfor">
    <div v-if="!showInsider && !showOtherStaff && !showRelation">
      <NavBar v-if="sourceIsH5" :narBarTitle="$t('编辑会议')" />
      <template v-if="mettingData">
        <div class="metting-association" @click="showRelation = true">
          <div class="metting-association-right">
            <div class="metting-association-title">
              <div class="metting-association-titel-big">
                {{ $t('会议关联') }}
              </div>
              <div class="metting-association-titel-small">
                {{ $t('（可快速导入会议数据）') }}
              </div>
            </div>
            <img src="@/assets/images/blueArrow.png" alt="" />
          </div>
          <div class="metting-association-name">
            {{
              relationMeeting.appointmentTopic
                ? relationMeeting.appointmentTopic
                : $t('无')
            }}
          </div>
        </div>
        <div class="metting-theme">
          <div class="metting-theme-title">
            <div class="metting-theme-icon">*</div>
            <div class="metting-theme-name">{{ $t('会议主题') }}</div>
          </div>
          <van-field v-model="themeName" type="textarea" :placeholder="$t('会议主题(50字以内)')" clearable center
            maxlength="50" class="content-title" autosize rows="1" @focus="removeRequired" @blur="hasRequired" />
        </div>
        <div class="metting-room" @click="toSelect" v-show="!ifOnline">
          <div class="metting-room-left">
            <img src="@/assets/images/location.png" alt="" />
            <span>{{ mettingRoomName }}</span>
          </div>
          <!-- <img src="@/assets/images/pull.png" alt="" /> -->
          <img src="@/assets/images/blueArrow.png" alt="" />
        </div>
        <div :class="isVideoconferencing == '3' ? 'encryptionDing' : 'encryption'" v-if="
          isVideoconferencing == 1 ||
          isVideoconferencing == 2 ||
          isVideoconferencing == 3
        ">
          <div :class="isVideoconferencing == '3'
            ? 'encryption-textDing'
            : 'encryption-text'
            ">
            {{
              isVideoconferencing == '3'
                ? $t('钉钉视频会议')
                : isVideoconferencing == '1'
                  ? $t('腾讯会议')
                  : $t('企微视频会议')
            }}
          </div>
          <van-switch size="22px" v-model="isShowVideo" :disabled="isVideoconferencing == '3'"
            :inactive-color="isVideoconferencing == '3' ? '#c0c0c0' : '#fff'" />
        </div>
        <div class="encryption" v-show="!ifOnline">
          <div class="encryption-text">{{ $t('加密会议') }}</div>
          <van-switch size="22px" v-model="encryption" :disabled="mettingData?.sensitivity == 'PRIVATE' ||
            mettingData?.sensitivity == 'CONFIDENTIAL'
            ? true
            : false
            " />
        </div>
        <van-calendar v-model:show="dateShow" @confirm="dateConfirm" color="#1989fa" :default-date="defaultDate" />
        <div class="informTime">
          <div class="informTime-top">
            <div @click="onDate">
              <div>
                {{
                  dayjs(
                    mettingData.appointmentStartTime,
                    'YYYY-MM-DD HH:mm:ss'
                  ).format($t('MM月DD日'))
                }}{{ $t('周')
                }}{{
                  week[
                  dayjs(
                    mettingData.appointmentStartTime,
                    'YYYY-MM-DD HH:mm:ss'
                  ).get('day')
                  ]
                }}
              </div>
            </div>
            <img src="@/assets/images/path.png" alt="" />
            <div @click="choseTime">
              <div>
                {{
                  this.invalidDate
                    ? '-'
                    : dayjs(
                      mettingData.appointmentStartTime,
                      'YYYY-MM-DD HH:mm:ss'
                    ).format('HH:mm') +
                    '-' +
                    dayjs(
                      mettingData.appointmentEndTime,
                      'YYYY-MM-DD HH:mm:ss'
                    ).format('HH:mm')
                }}
              </div>
            </div>
            <div class="totalTime">
              {{ $t('共') }}
              <div class="allTime">
                {{
                  this.invalidDate
                    ? 0
                    : dayjs(
                      mettingData.appointmentEndTime,
                      'YYYY-MM-DD HH:mm:ss'
                    ).diff(
                      dayjs(
                        mettingData.appointmentStartTime,
                        'YYYY-MM-DD HH:mm:ss'
                      ),
                      'minute'
                    )
                }}
              </div>
              {{ $t('分钟') }}
            </div>
          </div>
          <div class="informTime-bottom">
            <img src="@/assets/images/bell.png" alt="" />
            <span>{{ $t('会议开始前') }}{{ preMeetingReminderTime
            }}{{ $t('分钟提醒') }}</span>
          </div>
        </div>
        <div class="metting-room">
          <div class="meeting-invite">
            <!-- <img src="@/assets/images/behalfOfOthers.png" alt="" /> -->
            <div class="text">{{ $t('预定人') }}</div>
          </div>
          <div class="meeting-invite-name">{{ inviteName }}</div>
        </div>
        <div v-show="infoShowVideo && ifAgain == 1" class="metting-content">
          <div class="content-top">
            {{
              isVideoconferencing == '3'
                ? $t('钉钉视频会议')
                : isVideoconferencing == '1'
                  ? $t('腾讯视频会议')
                  : $t('企微视频会议')
            }}
          </div>
          <div class="tencent-info">
            <div class="encryption-text">{{ $t('入会链接：') }}</div>
            <div class="tencent-text">{{ meetingUrl }}</div>
            <div class="encryption-text">{{ $t(' 会议号：') }}</div>
            <div class="tencent-text">{{ meetingCode }}</div>
          </div>
        </div>
        <div class="metting-content">
          <div class="content-top">{{ $t('会议议程') }}</div>
          <van-field v-model="mettingContent" type="textarea" :placeholder="$t('请输入会议内容')" class="content-bottom"
            autosize />
        </div>
        <div class="themeCade" v-show="!ifOnline">
          <div class="title">{{ $t('附件') }}</div>
          <div class="filedList">
            <div v-for="item in filedList" :key="item.uid" @click="showFiled(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="confereeBox">
          <div class="confereeBox-top">
            <!-- <img src="@/assets/images/adduser.png" alt="" /> -->
            <div class="text">{{ $t('添加内部参会人') }}</div>
            <img src="@/assets/images/add.png" alt="" @click="showInsider = true" />
          </div>
          <div class="confereeBox-bottom">
            <InsiderBox v-for="(value, idx) in displayDepartmentList" :key="value.departmentId"
              :insiderName="value.departmentName" @click="delDepartment" :idx="idx" bColor="1"
              :id="value.departmentId" />
            <!-- todo -->
            <InsiderBox v-for="(value, idx) in displayStaffList" :key="value.id" :insiderName="value.name"
              @click="delInsiderList" bColor="2" :idx="idx" :id="value.id" :showClick="value.id !== user.id" />
          </div>
        </div>
        <div class="confereeBox" v-show="!ifOnline">
          <div class="confereeBox-top">
            <!-- <img src="@/assets/images/adduser.png" alt="" /> -->
            <div class="text">{{ $t('添加外部参会人') }}</div>
            <img src="@/assets/images/add.png" alt="" @click="showOutsider = true" />
          </div>
          <div class="outsiderWrap" v-show="outsiderList.length > 0">
            <div class="outsiderBox" v-for="(item, idx) in outsiderList" :key="item.email">
              <div class="outsiderMsg">
                <div class="outsiderName">{{ item.name }}</div>
                <div class="outsiderEMail">
                  {{ item.mobile ? item.mobile : item.email }}
                </div>
              </div>
              <div class="outsiderDel">
                <img src="@/assets/images/del.png" alt="" @click="delOutsiderList(idx)" />
              </div>
            </div>
          </div>
        </div>
        <van-dialog v-model="showOutsider" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
          @confirm="confirmOutsider" width="296px" class="outsiderStyle" :cancelButtonText="$t('暂不')"
          :confirmButtonText="$t('确定')">
          <template #title>
            <div class="outsider-title">{{ $t('添加外部参会人员') }}</div>
          </template>
          <van-form class="hasBorder">
            <van-field :label="$t('姓名')" name="username">
              <template #input>
                <input type="text" :placeholder="$t('请输入姓名')" v-model="outsiderName" class="outsider-input" />
              </template>
            </van-field>
            <van-field :label="$t('邮箱')" :rules="[{ required: true, validator: emailTest }]" name="eMail">
              <template #input>
                <input type="text" :placeholder="$t('请输入邮箱')" v-model="outsiderEmail" class="outsider-input" />
              </template>
            </van-field>
          </van-form>
        </van-dialog>
        <div class="metting-summary">
          <div class="text">{{ $t('会议纪要人') }}</div>
          <div class="metting-summary-left">
            <div class="meeting-summary-name">{{ summaryName }}</div>
            <img src="@/assets/images/blueArrow.png" alt="" @click="showSummaryStaff = true" />
          </div>
        </div>
        <!-- <div v-if="isReviewed" class="metting-phone">
          <div class="phoneText">{{ $t('手机号:') }}</div>
          <input type="text" :placeholder="$t('请输入')" v-model="phoneMobile" class="phone-input" />
        </div> -->
        <div class="metting-level">
          <div class="levelText">{{ $t('会议等级:') }}</div>
          <!-- <van-field name="radio">
          <template #input> -->
          <van-radio-group v-model="meetingLevel" direction="horizontal">
            <van-radio :name="0">{{ $t('无') }}</van-radio>
            <van-radio :name="1">{{ $t('1星') }}</van-radio>
            <van-radio :name="2">{{ $t('2星') }}</van-radio>
            <van-radio :name="3">{{ $t('3星') }}</van-radio>
          </van-radio-group>
          <!-- </template>
        </van-field> -->
        </div>
        <div class="metting-service" v-if="
          this.mettingData.openMeetingService !== undefined &&
          this.mettingData.openMeetingService !== null &&
          (!this.currentMettingRoom ||
            !this.currentMettingRoom.id ||
            this.currentMettingRoom.id == this.mettingData.meetingRoomId)
        ">
          <div class="serviceText">{{ $t('会务服务：') }}</div>
          <van-switch size="22px" v-model="openMeetingService" :disabled="!isHasService" />
        </div>
        <div class="metting-service" v-if="
          this.currentMettingRoom &&
          this.currentMettingRoom.id &&
          this.currentMettingRoom.id != this.mettingData.meetingRoomId &&
          isHasService
        ">
          <div class="serviceText">{{ $t('会务服务：') }}</div>
          <van-switch size="22px" v-model="openMeetingService" />
        </div>
        <!-- <div class="metting-people">
        <div class="metting-inside-people">
          <span>参会人：</span>
          <p>
            <ReadBox
              v-for="item in displayDepartmentList"
              :key="item.departmentId"
              :insiderName="item.departmentName"
              bColor="#009BFF"
            />
            <ReadBox v-for="item in displayStaffList" :key="item.id" :insiderName="item.name" />
          </p>
        </div>
        <div class="metting-outside-people">
          <span>外部参会人：</span>
          <div class="outside-people-box">
            <p
              v-for="(item, idx) in outsiderList"
              :key="idx + 7777"
              class="outside-font"
              :style="{ color: '#999999' }"
            >
              <span class="metting-outsider-name">{{ item.name }}</span>
              {{ item.email }}
            </p>
          </div>
        </div>
      </div> -->
        <!-- <div class="metting-sign">
          <span>会议签到:</span>
          <p>{{ getCurrentTemplate() ? `开启(${getCurrentTemplate()})` : '未开启' }}</p>
        </div> -->
        <div :style="{ textAlign: 'center', marginTop: '32px' }">
          <van-button round type="info" class="button" @click="submit">{{
            $t('确定')
            }}</van-button>
        </div>
      </template>
      <van-action-sheet v-model="show" :actions="mettingRoomList" :title="$t('选择地区')" @select="onSelect" />
      <van-popup v-model="showStatus" position="bottom" safe-area-inset-bottom>
        <div>
          <van-checkbox-group v-model="result" class="timeList">
            <div ref="rangeBox" style="position: absolute; top: 0; height: 113.07vw">
              <van-checkbox :name="idx" class="timeListCard" icon-size="21px"
                :disabled="ifFree(item.status, item.endTime)" v-for="(item, idx) in validMeetingTimeRange"
                :key="idx + 55000" @click="clickTime(idx)">
                <div class="timeListRange" :ref="'range' + idx">
                  {{ item.startTime }}~{{ item.endTime }}
                  <span v-if="item.extra">{{ item.extra }}</span>
                  <span v-else-if="item.conflict" style="color: #999">{{
                    $t('该时间已参加其他会议')
                    }}</span>
                  <span v-else-if="item.current" style="color: #009bff">{{
                    $t('当前时段')
                    }}</span>
                </div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="confirmTime">{{ $t('确定')
            }}</van-button>
        </div>
      </van-popup>
      <van-popup v-model="showSummaryStaff" position="bottom" safe-area-inset-bottom>
        <div>
          <div class="timeListTitle">{{ $t('选择会议纪要人') }}</div>
          <div v-if="!summaryList || !summaryList.length" class="noSummary">
            {{ $t('请先添加内部参会人') }}
          </div>
          <van-checkbox v-model="allCheck" @click="checkAll()" class="timeListAll">{{ $t('所有人') }}</van-checkbox>
          <van-checkbox-group v-model="summaryResult" class="timeList" v-if="summaryList && summaryList.length"
            ref="checkboxGroup">
            <div style="position: absolute; top: 0; height: 318px">
              <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in summaryList"
                :key="index" @click="clickSummary(index, item)">
                <div class="timeListRange">{{ item.name }}</div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="book-btn" @click="toSummaryInform">{{ $t('确定')
            }}</van-button>
        </div>
      </van-popup>
    </div>
    <Address :userList="userList" v-else-if="showInsider && !showOtherStaff && !showRelation" @back="toInform"
      @confirm="confirmSearch" :selectedList="insiderList" />
    <OtherStaff :userList="withoutSelfList" v-else-if="!showInsider && showOtherStaff && !showRelation" @back="toInform"
      @confirm="confirmOtherStaff" :selectedList="otherStaffData" />
    <Relation v-else-if="!showInsider && !showOtherStaff && showRelation" @back="toInform" @confirm="confirmRelation"
      :selectedList="relationMettingList" />

    <van-image-preview v-model="showImg" :images="imagesUrl"></van-image-preview>
    <van-popup v-model="isShowFiled" position="bottom" :style="{ height: '100%' }">
      <div class="offLineTitle">
        <div class="offLineTitlText">附件预览</div>
        <div class="offLineTitlClose" @click="isShowFiled = false">
          <van-icon name="cross" size="24px" />
        </div>
      </div>
      <iframe :src="url" width="100%" height="100%" frameborder="1" v-if="filedType == 'text'">
      </iframe>
      <iframe :src="url" width="100%" height="100%" frameborder="1" v-if="filedType == 'pdf'">
      </iframe>
      <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" v-if="filedType == 'video'"
        :style="{ height: '100%' }"></video-player>
    </van-popup>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import NavBar from '@/components/navBar'
import ReadBox from '@/components/readBox'
import Address from './address.vue'
import OtherStaff from './otherStaff.vue'
import InsiderBox from '@/components/insiderBox'
import Relation from './relation.vue'
import {
  getUserList,
  getTemplateList,
  webAppointmentUpdate,
  getMeetingRoomConfig,
  getMeetingRoomByArea,
  queryAppointmentList,
  getAppointmentByID,
  getstaffByDepartment,
  appointmentOnlineUpdate,
  getStaffById,
  bookAppointment,
  appointmentOnline,
  queryMyRelation,
  getHoliday,
  getMeetingRoomById,
} from '@/services/api'
import Vue from 'vue'
import {
  Field,
  Icon,
  Button,
  CellGroup,
  ActionSheet,
  Popup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Dialog,
  ImagePreview,
  Switch,
} from 'vant'
import VideoPlayer from 'vue-video-player'
import closeUnpayOrder$ from 'dingtalk-jsapi/api/biz/store/closeUnpayOrder'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(ImagePreview)
Vue.use(VideoPlayer)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(Switch)

export default {
  name: 'MettingInfor',
  components: {
    NavBar,
    ReadBox,
    Address,
    OtherStaff,
    InsiderBox,
    Relation,
  },
  data() {
    return {
      isRequired: true,
      user: {},
      meetingName: this.$t('会议标题会议标题'),
      inviteName: '',
      invalidDate: false, //时间段是否为过期时间
      mettingData: null,
      staffUseList: [],
      templateList: [],
      themeName: '',
      mettingRoomList: [],
      mettingRoomName: '',
      meetingStatusList: [],
      relationMeeting: {},
      relationMettingList: {},
      summaryName: '',
      summaryPeopleId: '',
      allCheck: false,
      summaryList: [],
      summaryResult: [],
      insiderList: [],
      outsiderList: [],
      originList: [],
      originDate: '',
      result: [],
      currentMettingRoom: null,
      mettingContent: '',
      show: false,
      parameterDate: '',
      week: [
        this.$t('日'),
        this.$t('一'),
        this.$t('二'),
        this.$t('三'),
        this.$t('四'),
        this.$t('五'),
        this.$t('六'),
      ],

      showStatus: false,
      totalInfo: [],
      displayStaffList: [],
      displayDepartmentList: [],
      meetingRoomConfig: {},
      sourceIsH5: true,
      showInsider: false,
      showOtherStaff: false,
      showRelation: false,
      showSummaryStaff: false,
      outsiderEmail: '',
      showOutsider: false,
      outsiderName: '',
      filedList: '',
      encryption: false,
      isShowVideo: false,
      isVideoconferencing: 0,
      infoShowVideo: false,
      meetingCode: '',
      meetingUrl: '',
      url: '',
      filedName: '',
      isShowFiled: false,
      filedType: '',
      showImg: false,
      ifOnline: false,
      ifAgain: 1, //是否是再次预约 1是否
      myRelationPage: 1,
      imagesUrl: [],
      playerOptions: {
        autoplay: true, //是否自动播放
        muted: false, //是否静音播放
        loop: false, //是否循环播放
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9', //比例
        fluid: true,
        sources: [
          {
            type: '',
            src: '',
          },
        ],
      },
      preMeetingReminderTime: null,
      devicesAIO: {},
      dateShow: false,
      defaultDate: '',
      isDate: '',
      selfSchedule: [],
      phoneMobile: '', //手机号
      meetingLevel: '',
      openMeetingService: false,
      isHasService: false,
    }
  },
  computed: {
    validMeetingTimeRange() {
      return this.meetingStatusList
        ?.filter(
          (v) =>
            dayjs(this.parameterDate + v.endTime).isAfter(dayjs()) &&
            v.endTime !== '24:00'
        )
        .map((v) => ({
          ...v,
          conflict: this.selfSchedule?.some((s) =>
            dayjs(this.parameterDate + v.endTime).isBetween(
              dayjs(s.beginTime),
              dayjs(s.endTime),
              'minutes',
              '(]'
            )
          ),
          current: dayjs().isBetween(
            dayjs(this.parameterDate + v.startTime),
            dayjs(this.parameterDate + v.endTime),
            'minutes',
            '[]'
          ),
        }))
    },
  },
  methods: {
    getALLInfo(roomId, ifOnline) {
      if (roomId && !ifOnline) {
        getMeetingRoomById(roomId).then((res) => {
          if (roomId == this.mettingData.meetingRoomId) {
            this.meetingManger = this.mettingData.meetingManger
            this.isHasService =
              res.openMeetingService && res.meetingManger ? true : false
          } else {
            if (res.openMeetingService && res.meetingManger) {
              this.isHasService = true
              this.meetingManger = res.meetingManger
            } else {
              this.isHasService = false
              this.meetingManger = ''
            }
          }
        })
      }
    },
    async getUserList(appointmentId) {
      const user = JSON.parse(localStorage.getItem('user'))
      const res = await getUserList({ companyId: user.companyId })
      this.staffUseList = res
      this.getInfo(this.mettingData.id)
      this.mettingData.otherPeopleRecord && this.getOutSidePeople()
      let arr = [...res]
      this.userList = arr
      this.withoutSelfList = this.userList.filter((item) => {
        return item.id != this.user.id
      })
      const info = await getAppointmentByID({ appointmentId })
      let nameList = [...info.attendDetails]
      if (info.attach) {
        let filed = JSON.parse(info.attach)
        this.filedList = filed
      }
      // let idList = nameList.map(item => item.staffId)
      // let tmp = []
      // this.userList.map(item => {
      //   idList.map(id => {
      //     if (item.id == id) {
      //       tmp.push(item)
      //     }
      //   })
      let idList = this.mettingData.meetingPeopleId.split(',')
      let tmp = this.userList.filter((item) => {
        if (this.mettingData.meetingPeopleId.includes(',')) {
          return idList.includes(item.id + '')
        } else {
          return this.mettingData.meetingPeopleId == item.id
        }
      })
      this.insiderList = tmp
    },
    async getInfo(appointmentId) {
      const info = await getAppointmentByID({ appointmentId })
      if (info.isVideoconferencing && info.isVideoconferencing == 1) {
        this.isShowVideo = true
        this.infoShowVideo = true
      } else {
        this.isShowVideo = false
        this.infoShowVideo = false
      }
      this.meetingCode = info?.meetingCode ? info.meetingCode : ''
      this.meetingUrl = info?.meetingUrl ? info.meetingUrl : ''
      if (info.sensitivity == 'PRIVATE' || info.sensitivity == 'CONFIDENTIAL') {
        this.encryption = true
      }
      let nameList = [...info.attendDetails]
      if (info.attach) {
        let filed = JSON.parse(info.attach)
        this.filedList = filed
      }
      if (info.meetingPeopleId.split(',').length > info.attendDetails.length) {
        const { name } = await getStaffById(info.appointmentStaff)
        info.attendDetails.push({
          agree: 'true',
          staffId: info.appointmentStaff,
          staffName: name,
        })
      }
      info.attendDetails.forEach((item) => {
        if (info.appointmentStaff == item.staffId) {
          this.inviteName = item.staffName
        }
      })
      // nameList.forEach((item, idx) => {
      //   if (item.agree === false) {
      //     nameList.splice(idx, 1)
      //   }
      // })
      let newIdList = info.meetingPeopleId.split(',')
      let tmp = this.userList.filter((item) => {
        if (info.meetingPeopleId.includes(',')) {
          return newIdList.includes(item.id + '')
        } else {
          return info.meetingPeopleId == item.id
        }
      })
      this.insiderList = tmp
      this.summaryList = tmp
      if (info.summaryUserDetails && info.summaryUserDetails.length) {
        let newIdList = []
        let newResult = []
        info.summaryUserDetails.map((peopel) => {
          this.summaryList.map((item, index) => {
            if (peopel.staffId == item.id) {
              newIdList.push(item.id)
              newResult.push(index)
            }
          })
        })
        this.summaryResult = newResult
        this.summaryPeopleId = newIdList.join(',')
        if (this.summaryList.length == info.summaryUserDetails.length) {
          this.allCheck = true
        } else {
          this.allCheck = false
        }
        this.summaryName =
          this.summaryList.length == info.summaryUserDetails.length
            ? this.$t('所有人')
            : info.summaryUserDetails.length == 1
              ? info.summaryUserDetails[0].staffName
              : info.summaryUserDetails[0].staffName +
              this.$t('等') +
              newResult.length +
              this.$t('人')
      }
      let idList = nameList.map((item) => item.staffId)
      let arr = this.staffUseList.filter((item) => idList.includes(item.id))
      this.getDepartment(this.user.companyId, arr)
    },
    onDate() {
      this.defaultDate = new Date(this.mettingData.appointmentStartTime)
      this.dateShow = true
    },
    dateConfirm(value) {
      this.isDate = value
      this.parameterDate = dayjs(value).format('YYYY-MM-DD')
      const nowDate = dayjs().format('YYYY-MM-DD')
      this.invalidDate = false
      if (!this.ifOnline) {
        this.getAppointmentList(
          this.user.companyId,
          this.parameterDate,
          this.mettingData.meetingRoomId
        )
      }
      if (
        dayjs(value).isSame(dayjs(), 'day') &&
        dayjs(
          `${nowDate} ${dayjs(
            this.mettingData.appointmentStartTime,
            'YYYY-MM-DD HH:mm:ss'
          ).format('HH:mm')}`
        ).isBefore(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'))
      ) {
        this.result = []
        this.invalidDate = true
        Toast.fail(this.$t('会议时间段不可为无效时间段，请重新选择'))
      } else {
        const startIdx = this.validMeetingTimeRange?.findIndex?.(
          (v) => v.startTime == this.mettingData.appointmentStartTime
        )
        const endIdx = this.validMeetingTimeRange?.findIndex?.(
          (v) => v.endTime == this.mettingData.appointmentEndTime
        )

        console.log('startIdx', startIdx, 'endIdx', endIdx)
        this.result = []
        if (startIdx > 0 && endIdx > 0) {
          // 补全startIdx, endIdx之间的值
          for (let index = startIdx; index <= endIdx; index++) {
            this.result = this.result.concat(index)
          }
        }
        console.log('result', this.result)
      }
      const year = value.getFullYear()
      const month = value.getMonth()
      const day = value.getDate()
      const startTime = new Date(this.mettingData.appointmentStartTime)
      const endTime = new Date(this.mettingData.appointmentEndTime)
      startTime.setFullYear(year)
      startTime.setMonth(month)
      startTime.setDate(day)
      endTime.setFullYear(year)
      endTime.setMonth(month)
      endTime.setDate(day)
      this.mettingData.appointmentStartTime = dayjs(startTime).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.mettingData.appointmentEndTime = dayjs(endTime).format(
        'YYYY-MM-DD HH:mm:ss'
      )

      this.dateShow = false
    },
    getOutSidePeople() {
      let userOutSideList = []
      JSON.parse(this.mettingData.otherPeopleRecord).forEach((item) =>
        userOutSideList.push(item)
      )
      this.outsiderList = [...userOutSideList]
    },
    async getTemplateList() {
      const data = {}
      const user = JSON.parse(localStorage.getItem('user'))
      if (user.companyId) {
        data['developerId'] = user.companyId
        data['companyId'] = user.companyId
        const res = await getTemplateList(data)
        this.templateList = res
      }
    },
    getCurrentTemplate() {
      if (this.templateList && this.mettingData) {
        const name = this.templateList.find(
          (item) => item.id == this.mettingData.signTemplateId
        )?.name
        return name
      }
    },
    toSelect() {
      this.show = true
    },
    onSelect(data) {
      this.mettingRoomName = data.name
      this.currentMettingRoom = data
      this.getAppointmentList(this.user.companyId, this.parameterDate, data.id)
      this.show = false
    },
    checkAll() {
      if (this.allCheck) {
        this.$refs.checkboxGroup.toggleAll(true)
      } else {
        this.$refs.checkboxGroup.toggleAll()
      }
    },
    clickSummary(index) {
      if (this.summaryResult.length == this.summaryList.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
      if (this.summaryResult.length < 2) return
      if (!this.summaryResult.some((num) => num == index)) return
    },
    toSummaryInform() {
      if (this.summaryResult.length == 0) {
        Toast.fail(this.$t('会议纪要人不能为空'))
        return
      }
      this.summaryResult.sort(function (a, b) {
        return a - b
      })
      let newName = ''
      let newIds = []
      if (this.summaryResult.length == this.summaryList.length) {
        newName = this.$t('所有人')
      } else if (this.summaryResult.length > 1) {
        newName =
          this.summaryList[this.summaryResult[0]].name +
          this.$t('等') +
          this.summaryResult.length +
          this.$t('人')
      } else {
        newName = this.summaryList[this.summaryResult[0]].name
      }
      this.summaryResult.map((item, index) => {
        newIds.push(this.summaryList[item].id)
      })
      this.summaryName = newName
      this.summaryPeopleId = newIds.join(',')
      this.showSummaryStaff = false
    },
    removeRequired() {
      this.isRequired = false
    },
    hasRequired() {
      if (this.meetingTheme) {
        this.isRequired = false
      } else {
        this.isRequired = true
      }
    },
    choseTime() {
      this.showStatus = true
    },
    async submit() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (!this.mettingData) {
        return
      }
      if (!this.themeName) {
        Toast.fail(this.$t('输入会议主题'))
        return
      }
      if (this.invalidDate) {
        Toast.fail(this.$t('请选择会议时间'))
        return
      }
      if (this.meetingRoomConfig.scheduledDateLimit != 'everyday') {
        const ifHoliday = await getHoliday(
          dayjs(this.isDate).format('YYYYMMDD')
        )
        if (ifHoliday == 1) {
          Toast.fail(this.$t('节假日不能预约会议室'))
          return
        }
      }
      // if (this.isReviewed && !this.mobileTest()) {
      //   Toast.fail(this.$t('手机号输入错误'))
      //   return
      // }
      if (
        dayjs(this.mettingData.appointmentEndTime).valueOf() -
        dayjs(this.mettingData.appointmentStartTime).valueOf() >
        this.meetingRoomConfig.scheduledMaxTime * 60 * 60 * 1000
      ) {
        let maxTime = 0
        if (this.meetingRoomConfig.scheduledMaxTime >= 1) {
          maxTime =
            this.meetingRoomConfig.scheduledMaxTime + ' ' + this.$t('小时')
        } else {
          maxTime =
            this.meetingRoomConfig.scheduledMaxTime * 60 + ' ' + this.$t('分钟')
        }
        Toast.fail(
          this.$t('超过最大预约时间段:{maxTime}', { maxTime: maxTime })
        )
        return
      }
      let meetingPeopleId = this.insiderList.map((item) => item.id)
      let peopleId = []
      this.insiderList.forEach((item) => {
        if (item.departmentId.includes(',')) {
          let departmentList = item.departmentId.split(',')
          departmentList.forEach((departmentId) =>
            peopleId.push(item.id + '-' + departmentId)
          )
        } else {
          peopleId.push(item.id + '-' + item.departmentId)
        }
      })
      // todo
      let data = {}
      if (this.ifAgain == 1) {
        data = {
          id: this.mettingData.id,
          developerId: user.companyId,
          companyId: user.companyId,
          meetingRecord: this.mettingContent,
          appointmentTopic: this.themeName,
          appointmentStaff: this.mettingData.appointmentStaff,
          appointmentEndTime: this.mettingData.appointmentEndTime,
          appointmentStartTime: this.mettingData.appointmentStartTime,
          meetingPeopleId: meetingPeopleId.join(),
          peopleId: peopleId.join(','),
          relationMeetingId: this.relationMeeting.id,
          summaryPeopleId: this.summaryPeopleId,
          isVideoconferencing: this.isShowVideo ? 1 : 0,
          meetingCode: this.meetingCode || undefined,
          meetingUrl: this.meetingUrl || undefined,
          sensitivity: this.encryption ? 'PRIVATE' : 'NORMAL',
          remindTime: this.preMeetingReminderTime,
          signBeforeMinute: this.devicesAIO?.signBeforeMinute || 10,
          signAfterMinute: this.devicesAIO?.signAfterMinute || 10,
          noSignReleaseTime: this.devicesAIO?.noSignReleaseTime || 10,
          preMeetingReminderTime: this.preMeetingReminderTime,
          meetingLevel: this.meetingLevel ? this.meetingLevel : 0,
          openMeetingService:
            this.openMeetingService !== undefined &&
              this.openMeetingService !== null
              ? this.openMeetingService
                ? this.openMeetingService
                : false
              : undefined,
          meetingManger: this.meetingManger ? this.meetingManger : undefined,
        }
      } else {
        data = {
          developerId: user.companyId,
          companyId: user.companyId,
          meetingRecord: this.mettingContent,
          appointmentTopic: this.themeName,
          appointmentStaff: this.mettingData.appointmentStaff,
          appointmentEndTime: this.mettingData.appointmentEndTime,
          appointmentStartTime: this.mettingData.appointmentStartTime,
          meetingPeopleId: meetingPeopleId.join(),
          peopleId: peopleId.join(','),
          isVideoconferencing: this.isShowVideo ? 1 : 0,
          sensitivity: this.encryption ? 'PRIVATE' : 'NORMAL',
          replaceAppointmentStaff: this.mettingData.replaceAppointmentStaff
            ? this.mettingData.replaceAppointmentStaff
            : undefined,
          remindTime: 15,
          repeatType: 'single',
          relationMeetingId: this.relationMeeting.id,
          summaryPeopleId: this.summaryPeopleId,
          remindTime: this.preMeetingReminderTime,
          signBeforeMinute: this.devicesAIO?.signBeforeMinute || 10,
          signAfterMinute: this.devicesAIO?.signAfterMinute || 10,
          noSignReleaseTime: this.devicesAIO?.noSignReleaseTime || 10,
          preMeetingReminderTime: this.preMeetingReminderTime,
          meetingLevel: this.meetingLevel ? this.meetingLevel : 0,
          openMeetingService:
            this.openMeetingService !== undefined &&
              this.openMeetingService !== null
              ? this.openMeetingService
                ? this.openMeetingService
                : false
              : undefined,
          meetingManger: this.meetingManger ? this.meetingManger : undefined,
        }
      }
      if (this.ifOnline) {
        if (this.ifAgain == 1) {
          await appointmentOnlineUpdate(data)
        } else {
          await appointmentOnline(data)
        }
        Toast.success(this.$t('保存成功'))
        this.$router.push('bookMeetings')
      } else {
        try {
          if (this.ifAgain == 1) {
            await webAppointmentUpdate({
              ...data,
              otherPeopleRecord:
                this.outsiderList && this.outsiderList.length > 0
                  ? JSON.stringify(this.outsiderList)
                  : '',
              meetingRoomId:
                (this.currentMettingRoom && this.currentMettingRoom.id) ||
                this.mettingData.meetingRoomId,
            }).then(() => {
              Toast.success(this.$t('保存成功'))
              this.$router.push('bookMeetings')
            })
          } else {
            await bookAppointment({
              ...data,
              multiMeetingRoomIds: [
                (this.currentMettingRoom && this.currentMettingRoom.id) ||
                this.mettingData.meetingRoomId,
              ],

              otherPeopleRecord:
                this.outsiderList && this.outsiderList.length > 0
                  ? JSON.stringify(this.outsiderList)
                  : '',
            })
            Toast(this.$t('会议预约成功'))
            this.$router.push('meeting')
          }
        } catch (err) {
          Toast.fail(err.response.data)
        }
      }
    },
    getNowFormatDate(date) {
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    ifFree(color, date) {
      date = this.getNowFormatDate(this.originDate) + ' ' + date
      // if (dayjs().valueOf() >= dayjs(date).valueOf()) {
      //   return true
      // } else
      {
        if (color == '#FFFFFF') {
          return false
        } else {
          return true
        }
      }
    },
    dislodgeZero(str) {
      if (str[0] == '0') {
        return (str = str.substring(1, 2))
      } else {
        return (str = str.substring(0, 2))
      }
    },
    toTime(hour, min) {
      if (hour == 0) {
        hour = '00'
      }
      if (hour < 10 && hour > 0) {
        hour = '0' + hour
      }
      if (min < 10) {
        min = '0' + min
      }
      if (min == 60) {
        min = '00'
        hour = hour - 0 + 1
        if (hour < 10) {
          hour = '0' + hour
        }
      }
      if (min == 0) {
        min = '00'
      }
      return hour + ':' + min
    },

    // 获取会时间
    async getMeetingTimeRange(developerId) {
      try {
        const res = await getMeetingRoomConfig({
          developerId,
        })
        this.preMeetingReminderTime = res?.preMeetingReminderTime
          ? res.preMeetingReminderTime
          : 15
        const newData = {
          signBeforeMinute: res?.signBeforeMinute || 10,
          signAfterMinute: res?.signAfterMinute || 10,
          noSignReleaseTime: res?.noSignReleaseTime || 10,
        }
        this.devicesAIO = newData
        this.meetingRoomConfig = { ...res }
        let timeUnit = 60 / res.timeUnit
        if (this.ifOnline) {
          let onlineTime = []
          for (let i = 0; i <= 24; i++) {
            onlineTime.push(i)
          }
          let onlineLength = 24 * timeUnit
          let onlineConfig = []
          for (let i = 0; i < onlineLength; i++) {
            onlineConfig.push({
              startTime: this.toTime(
                parseInt(i / timeUnit),
                i * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              endTime: this.toTime(
                parseInt(i / timeUnit),
                (i + 1) * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              status: '#FFFFFF',
            })
          }
          //过滤掉已过去的时间后再判断是否选中
          let newConfigArr = onlineConfig?.filter(
            (v) =>
              dayjs(this.parameterDate + v.endTime).isAfter(dayjs()) &&
              v.endTime !== '24:00'
          )
          newConfigArr.forEach((v, idx) => {
            let currentDate = dayjs(
              this.mettingData.appointmentStartTime,
              'YYYY-MM-DD HH:mm:ss'
            ).format('YYYY-MM-DD HH:mm:ss')
            let startTime =
              dayjs(currentDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') +
              ' ' +
              v.startTime +
              ':00'
            let endTime =
              dayjs(currentDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') +
              ' ' +
              v.endTime +
              ':00'
            if (
              (startTime >= this.mettingData.appointmentStartTime &&
                endTime <= this.mettingData.appointmentEndTime) ||
              (dayjs(this.mettingData.appointmentStartTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                endTime != this.mettingData.appointmentStartTime) ||
              (dayjs(this.mettingData.appointmentEndTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                startTime != this.mettingData.appointmentEndTime)
            ) {
              this.result.push(idx)
            }
          })
          // onlineConfig.forEach((v, idx) => {
          //   let currentDate = dayjs(
          //     this.mettingData.appointmentStartTime,
          //     'YYYY-MM-DD HH:mm:ss'
          //   ).format('YYYY-MM-DD HH:mm:ss')
          //   let startTime =
          //     dayjs(currentDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') +
          //     ' ' +
          //     v.startTime +
          //     ':00'
          //   let endTime =
          //     dayjs(currentDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') +
          //     ' ' +
          //     v.endTime +
          //     ':00'
          //   if (
          //     startTime >= this.mettingData.appointmentStartTime &&
          //     endTime <= this.mettingData.appointmentEndTime
          //   ) {
          //     this.result.push(idx)
          //   }
          // })
          this.originList = onlineConfig
          this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))
        } else {
          if (res.scheduledEndTime == '23:59') {
            res.scheduledEndTime = '24:00'
          }
          let startTime = this.dislodgeZero(res.scheduledStartTime) - 0
          let endTime = this.dislodgeZero(res.scheduledEndTime) - 0
          let length = (endTime - startTime) * timeUnit
          let configArr = []
          for (let i = 0; i < length; i++) {
            configArr.push({
              startTime: this.toTime(
                startTime + parseInt(i / timeUnit),
                i * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              endTime: this.toTime(
                startTime + parseInt(i / timeUnit),
                (i + 1) * res.timeUnit - 60 * parseInt(i / timeUnit)
              ),
              status: '#FFFFFF',
            })
          }
          //过滤掉已过去的时间后再判断是否选中
          let newConfigArr = configArr?.filter(
            (v) =>
              dayjs(this.parameterDate + v.endTime).isAfter(dayjs()) &&
              v.endTime !== '24:00'
          )
          newConfigArr.forEach((v, idx) => {
            let currentDate = dayjs(
              this.mettingData.appointmentStartTime
            ).format('YYYY-MM-DD')
            let startTime = currentDate + ' ' + v.startTime + ':00'
            let endTime = currentDate + ' ' + v.endTime + ':00'
            if (
              (startTime >= this.mettingData.appointmentStartTime &&
                endTime <= this.mettingData.appointmentEndTime) ||
              (dayjs(this.mettingData.appointmentStartTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                endTime != this.mettingData.appointmentStartTime) ||
              (dayjs(this.mettingData.appointmentEndTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                startTime != this.mettingData.appointmentEndTime)
            ) {
              this.result.push(idx)
            }
          })
          // configArr.forEach((v, idx) => {
          //   let currentDate = dayjs(this.mettingData.appointmentStartTime).format('YYYY-MM-DD')
          //   let startTime = currentDate + ' ' + v.startTime + ':00'
          //   let endTime = currentDate + ' ' + v.endTime + ':00'
          //   if (
          //     startTime >= this.mettingData.appointmentStartTime &&
          //     endTime <= this.mettingData.appointmentEndTime
          //   ) {
          //     this.result.push(idx)
          //   }
          // })
          this.originList = configArr
          this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))
        }
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    confirmTime() {
      this.invalidDate = false
      if (this.result.length == 0) {
        Toast.fail(this.$t('预约时间段不能为空'))
        return
      }
      this.result.sort(function (a, b) {
        return a - b
      })
      let continuous = this.result.every((val, idx) => {
        if (idx == this.result.length - 1) {
          return true
        } else {
          return this.result[idx + 1] - val == 1
        }
      })
      if (continuous) {
        let currentDate = dayjs(
          this.mettingData.appointmentStartTime,
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD HH:mm:ss')
        let appointmentStartTime = dayjs(
          dayjs(currentDate).format('YYYY-MM-DD') +
          ' ' +
          this.validMeetingTimeRange[this.result[0]].startTime +
          ':00',
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD HH:mm:ss')
        let appointmentEndTime = dayjs(
          dayjs(currentDate).format('YYYY-MM-DD') +
          ' ' +
          this.validMeetingTimeRange[this.result[this.result.length - 1]]
            .endTime +
          ':00',
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD HH:mm:ss')
        this.mettingData.appointmentStartTime = appointmentStartTime
        this.mettingData.appointmentEndTime = appointmentEndTime
        this.showStatus = false
      } else {
        Toast.fail(this.$t('预约时间段之间需连续'))
      }
    },
    // delInsiderList(idx) {
    //   this.insiderList.splice(idx, 1)
    // },
    async getMeetingRoomInformation(developerId, areaId) {
      try {
        const res = await getMeetingRoomByArea({
          developerId,
          areaId,
        })
        let tmpArr = [...res]
        tmpArr.forEach((item, idx) => {
          if (item.state === 'nouse') {
            // tmpArr.splice(idx, 1)
          }
        })
        tmpArr.forEach((item) => {
          if (item.state != 'nouse') {
            this.mettingRoomList.push({ name: item.name, id: item.id })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getRelationMetting(user) {
      try {
        let params = {
          companyId: user.companyId,
          staffId: user.id,
          page: this.myRelationPage,
          pageSize: 10,
        }
        const res = await queryMyRelation(params)
      } catch (error) {
        console.log(error)
      }
    },
    async getAppointmentList(companyId, date, meetingRoomId) {
      try {
        let res = await queryAppointmentList({
          date,
          meetingRoomId,
          companyId,
        })
        if (res.length == 0) return
        res.sort(
          (a, b) =>
            dayjs(a.appointmentStartTime).valueOf() -
            dayjs(b.appointmentStartTime).valueOf()
        )
        let ifAdvanced = false
        this.meetingStatusList = JSON.parse(JSON.stringify(this.originList))

        this.meetingStatusList.forEach((item) => {
          let startTime = dayjs(date + ' ' + item.startTime).valueOf()
          let endTime = dayjs(date + ' ' + item.endTime).valueOf()
          res.forEach((v, index) => {
            if (v.appointmentStaff == -1) {
              if (
                (startTime >= dayjs(v.appointmentStartTime).valueOf() &&
                  startTime <= dayjs(v.appointmentEndTime).valueOf()) ||
                (endTime >= dayjs(v.appointmentStartTime).valueOf() &&
                  endTime <= dayjs(v.appointmentEndTime).valueOf()) ||
                (dayjs(v.appointmentStartTime).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  endTime != dayjs(v.appointmentStartTime).valueOf()) ||
                (dayjs(v.appointmentEndTime).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  startTime != dayjs(v.appointmentEndTime).valueOf())
              ) {
                item.status = '#84C144'
                item.extra = this.$t('已被临时人员预订')
                if (
                  v.actualEndTime &&
                  dayjs(v.actualEndTime).valueOf() < dayjs(endTime).valueOf()
                ) {
                  item.extra = ``
                  item.status = '#FFFFFF'
                }
                if (endTime <= dayjs().valueOf()) {
                  item.extra = ``
                  item.status = '#FFFFFF'
                }
                return
              }
            }
            //判断会议提前开始占用的时间段
            if (
              v.actualStartTime &&
              v.appointmentStaff !== -1 &&
              ((dayjs(v.actualStartTime).valueOf() >= startTime &&
                dayjs(v.actualStartTime).valueOf() <= endTime) ||
                (dayjs(v.actualStartTime).valueOf() <= endTime &&
                  dayjs(v.appointmentStartTime).valueOf() >= endTime))
            ) {
              ifAdvanced = true
            } else {
              ifAdvanced = false
            }
            if (
              ifAdvanced ||
              (startTime >= dayjs(v.appointmentStartTime).valueOf() &&
                endTime <= dayjs(v.appointmentEndTime).valueOf()) ||
              (dayjs(v.appointmentStartTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                endTime != dayjs(v.appointmentStartTime).valueOf()) ||
              (dayjs(v.appointmentEndTime).isBetween(
                dayjs(startTime),
                dayjs(endTime),
                'minutes',
                '[]'
              ) &&
                startTime != dayjs(v.appointmentEndTime).valueOf())
            ) {
              item.extra =
                v.meetingSource == 'PROCESS'
                  ? this.$t('已被{slot1}申请', { slot1: v.staffName })
                  : this.$t('已被{slot1}预订', { slot1: v.staffName })
              item.status = '#F7B500'
              let hasNoOther = true
              if (res.length > 1) {
                if (index == 0) {
                  if (
                    (dayjs(res[1].appointmentStartTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      endTime !=
                      dayjs(res[1].appointmentStartTime).valueOf()) ||
                    (dayjs(res[1].appointmentEndTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      startTime != dayjs(res[1].appointmentEndTime).valueOf())
                  ) {
                    hasNoOther = false
                  } else {
                    hasNoOther = true
                  }
                } else if (index == res.length - 1) {
                  if (
                    (dayjs(res[index - 1].appointmentStartTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      endTime !=
                      dayjs(res[index - 1].appointmentStartTime).valueOf()) ||
                    (dayjs(res[index - 1].appointmentEndTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      startTime !=
                      dayjs(res[index - 1].appointmentEndTime).valueOf())
                  ) {
                    hasNoOther = false
                  } else {
                    hasNoOther = true
                  }
                } else {
                  if (
                    (dayjs(res[index - 1].appointmentStartTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      endTime !=
                      dayjs(res[index - 1].appointmentStartTime).valueOf()) ||
                    (dayjs(res[index - 1].appointmentEndTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      startTime !=
                      dayjs(res[index - 1].appointmentEndTime).valueOf()) ||
                    (dayjs(res[index + 1].appointmentStartTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      endTime !=
                      dayjs(res[index + 1].appointmentStartTime).valueOf()) ||
                    (dayjs(res[index + 1].appointmentEndTime).isBetween(
                      dayjs(startTime),
                      dayjs(endTime),
                      'minutes',
                      '[]'
                    ) &&
                      startTime !=
                      dayjs(res[index + 1].appointmentEndTime).valueOf())
                  ) {
                    hasNoOther = false
                  } else {
                    hasNoOther = true
                  }
                }
              }

              if (hasNoOther) {
                if (
                  (startTime >=
                    dayjs(this.mettingData.appointmentStartTime).valueOf() &&
                    endTime <=
                    dayjs(this.mettingData.appointmentEndTime).valueOf()) ||
                  (dayjs(this.mettingData.appointmentStartTime).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    endTime !=
                    dayjs(this.mettingData.appointmentStartTime).valueOf()) ||
                  (dayjs(this.mettingData.appointmentEndTime).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    startTime !=
                    dayjs(this.mettingData.appointmentEndTime).valueOf())
                ) {
                  if (v.appointmentStaff == this.user.id) {
                    item.status = '#FFFFFF'
                  } else {
                    item.status = '#F7B500'
                  }
                }
                if (v.state == 'cancel') {
                  item.status = '#FFFFFF'
                  item.extra = ''
                }
                if (
                  v.actualEndTime &&
                  dayjs(v.actualEndTime).valueOf() < dayjs(endTime).valueOf()
                ) {
                  item.extra = ``
                  item.status = '#FFFFFF'
                }
              } else {
                item.extra = this.$t('已被{slot1}等人预订', {
                  slot1: v.staffName,
                })
              }
            }
          })
        })
        this.getALLInfo(meetingRoomId, this.ifOnline)
      } catch (error) {
        console.log(error)
      }
    },
    //上级部门查询
    checkSuperiorDepartment(data, departmentId, arr) {
      let response = null
      if (data.pid) {
        let pidDepartmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          data.pid
        )
        let slectedNum = this.insiderList.filter(
          (item) => item.departmentId == pidDepartmentInfo.departmentId
        ).length
        if (
          slectedNum + data.totalStaffCount ==
          pidDepartmentInfo.totalStaffCount
        ) {
          let childData = pidDepartmentInfo.children.filter(
            (item) => item.departmentId == departmentId
          )[0]
          response = this.checkSuperiorDepartment(
            pidDepartmentInfo,
            pidDepartmentInfo.departmentId,
            arr,
            childData
          )
        } else {
          response = data
          return response
        }
      } else {
        response = data
        return response
      }
      return response
    },
    //下级部门查询
    checkSubordinateDepartment(data, selectedIdList) {
      let bl = true
      if (data.staffs && data.staffs.length > 0) {
        bl = data.staffs.every((childStaff) =>
          selectedIdList.includes(childStaff.staffId)
        )
      }
      if (bl && data.children.length > 0) {
        data.children.forEach((item) => {
          bl = this.checkSubordinateDepartment(item, selectedIdList)
        })
      }
      return bl
    },
    checkTotalStaffCount(data, id) {
      let selectedData = {}
      data.some((item) => {
        if (item.departmentId == id) {
          selectedData = item
          return true
        } else {
          if (item.children && item.children.length > 0) {
            let returnData = this.checkTotalStaffCount(item.children, id)
            returnData.staffs && (selectedData = returnData)
          } else return
        }
      })
      return selectedData
    },
    fliterDepartment(data, arr) {
      data.forEach((item) => {
        item.staffs &&
          item.staffs.length > 0 &&
          item.staffs.forEach((staffItem) => arr.push(staffItem.staffId))
        item.children.length > 0 && this.fliterDepartment(item.children, arr)
      })
      return arr
    },
    async getDepartment(companyId, list) {
      const res = await getstaffByDepartment({ companyId })
      this.totalInfo = res
      this.checkDepartment(list)
    },
    checkDepartment(data) {
      let arr = []
      data.forEach((item) => {
        if (item.departmentId.includes(',')) {
          let departmentIdList = item.departmentId.split(',')
          departmentIdList.forEach((id) => arr.push(id))
        } else arr.push(item.departmentId)
      })
      arr = Array.from(new Set(arr))
      let selectedIdList = data.map((item) => item.id)
      let department = []
      let includeDepartment = []
      arr.forEach((departmentId) => {
        let slectedNum = data.filter((item) => {
          if (item.departmentId.includes(',')) {
            let departmentIdList = item.departmentId.split(',')
            return departmentIdList.includes(departmentId)
          } else return item.departmentId == departmentId
        }).length
        let departmentInfo = this.checkTotalStaffCount(
          this.totalInfo,
          departmentId
        )
        if (
          departmentInfo.staffs &&
          slectedNum == departmentInfo.staffs.length
        ) {
          //判断是否最底层部门
          if (departmentInfo.children.length == 0) {
            let finalDepartment = this.checkSuperiorDepartment(
              departmentInfo,
              departmentId,
              arr
            )
            finalDepartment &&
              department.every(
                (item) => item.departmentId != finalDepartment.departmentId
              ) &&
              department.push(finalDepartment)
          } else {
            let ifAllChildSelected = []
            departmentInfo.children.forEach((childItem) => {
              let bl = this.checkSubordinateDepartment(
                childItem,
                selectedIdList
              )
              ifAllChildSelected.push(bl)
            })
            if (ifAllChildSelected.every((item) => item == true)) {
              let finalDepartment = this.checkSuperiorDepartment(
                departmentInfo,
                departmentId,
                arr
              )
              if (
                finalDepartment &&
                department.every(
                  (item) => item.departmentId != finalDepartment.departmentId
                )
              ) {
                department.push(finalDepartment)
                this.handlerFinalDepartment(finalDepartment, includeDepartment)
              }
            } else return
          }
        }
      })
      includeDepartment = Array.from(new Set(includeDepartment))
      department = department.filter((item) => {
        if (item.pid) {
          return (
            !includeDepartment.includes(item.pid) &&
            !includeDepartment.includes(item.departmentId)
          )
        } else return true
      })
      // this.displayDepartmentList = [...department]
      // let staffInDepartment = []
      // staffInDepartment = this.fliterDepartment(department, staffInDepartment)
      // this.displayStaffList = this.insiderList.filter(item => !staffInDepartment.includes(item.id))
      this.displayDepartmentList = []
      this.displayStaffList = this.insiderList
    },
    handlerFinalDepartment(data, idList) {
      if (data.children.length > 0) {
        data.children.forEach((item) => {
          idList.push(item.departmentId)
          if (item.children.length > 0) {
            this.handlerFinalDepartment(item, idList)
          }
        })
      }
    },
    clickTime(index) {
      if (this.result.length < 2) return
      if (!this.result.some((num) => num == index)) return
      let arr = [...this.result]
      arr.sort((a, b) => a - b)
      let addList = []
      let ifOccupied = false
      for (let i = arr[0]; i <= arr[arr.length - 1]; i++) {
        if (this.validMeetingTimeRange[i].status !== '#FFFFFF') {
          this.result = arr.filter((num) => num != index)
          ifOccupied = true
          Toast.fail(this.$t('预约时间段之间存在已被占用的时间段'))
          break
        }
        addList.push(i)
      }
      if (!ifOccupied) {
        this.result = addList
      }
    },
    delDepartment(id, idx) {
      this.AllDelete(this.totalInfo, id)
      this.displayDepartmentList.splice(idx, 1)
      if (this.displayDepartmentList.length > 0) {
        this.checkDepartment(this.insiderList)
      }
    },
    AllDelete(data, id) {
      data.forEach((item) => {
        if (id) {
          if (item.departmentId == id) {
            if (item.staffs && item.staffs.length > 0) {
              item.staffs.forEach((staffItem) =>
                this.delStaffIdList(staffItem.staffId)
              )
            }
            if (item.children.length > 0) {
              this.AllDelete(item.children)
            } else return
          } else {
            if (item.children.length > 0) {
              this.AllDelete(item.children, id)
            } else return
          }
        } else {
          if (item.staffs && item.staffs.length > 0) {
            item.staffs.forEach((staffItem) =>
              this.delStaffIdList(staffItem.staffId)
            )
          }
          if (item.children.length > 0) {
            this.AllDelete(item.children)
          } else return
        }
      })
    },
    delStaffIdList(id) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      this.summaryList = this.insiderList
      if (this.summaryList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
          summaryPeopleList.map((peopel) => {
            this.summaryList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          if (this.summaryList.length == newResult.length) {
            this.allCheck = true
          } else {
            this.allCheck = false
          }
          this.summaryName =
            this.summaryList.length == newResult.length
              ? this.$t('所有人')
              : newResult.length == 1
                ? (this.summaryList[newResult[0]] &&
                  this.summaryList[newResult[0]].name) ||
                ''
                : this.$t('{slot1} 等', {
                  slot1:
                    (this.summaryList[newResult[0]] &&
                      this.summaryList[newResult[0]].name) ||
                    '',
                }) +
                newResult.length +
                this.$t('人')
        }
      }
    },
    delInsiderList(id, idx) {
      this.insiderList = this.insiderList.filter((item) => item.id != id)
      this.summaryList = this.insiderList
      if (this.summaryList.length == 0) {
        this.summaryName = this.$t('无')
        this.summaryPeopleId = ''
        this.summaryResult = []
      } else {
        let summaryPeopleList = this.summaryPeopleId.split(',')
        let newResult = []
        let newIdList = []
        if (summaryPeopleList && summaryPeopleList.length) {
          summaryPeopleList.map((peopel) => {
            this.summaryList.map((item, index) => {
              if (peopel == item.id) {
                newIdList.push(item.id)
                newResult.push(index)
              }
            })
          })
          this.summaryResult = newResult
          this.summaryPeopleId = newIdList.join(',')
          if (this.summaryList.length == newResult.length) {
            this.allCheck = true
          } else {
            this.allCheck = false
          }
          this.summaryName =
            this.summaryList.length == newResult.length
              ? this.$t('所有人')
              : newResult.length == 1
                ? this.summaryList[0].name
                : this.summaryList[0].name +
                this.$t('等') +
                this.summaryList.length +
                this.$t('人')
        }
      }
      this.displayStaffList.splice(idx, 1)
    },
    delOutsiderList(idx) {
      this.outsiderList.splice(idx, 1)
    },
    async confirmRelation(data) {
      if (data) {
        this.relationMeeting = data
        this.relationMettingList = data
        let appointmentId = data.id
        try {
          await Dialog.confirm({
            message: this.$t('是否要导入会议数据！'),
            messageAlign: 'center',
            cancelButtonText: this.$t('取消'),
            confirmButtonText: this.$t('确定'),
            confirmButtonColor: '#009BFF',
            cancelButtonColor: '#009BFF',
            allowHtml: true,
          })
          const info = await getAppointmentByID({ appointmentId })
          this.themeName = info.appointmentTopic
          this.mettingContent = info.meetingRecord
          this.getInfo(appointmentId)
          if (info.otherPeopleRecord) {
            let userOutSideList = []
            JSON.parse(info.otherPeopleRecord).forEach((item) =>
              userOutSideList.push(item)
            )
            this.outsiderList = [...userOutSideList]
          }
        } catch (err) {
          console.log(err)
        }
      }
      this.showRelation = false
    },
    confirmSearch(data, displayData, total) {
      this.insiderList = [...data]
      this.summaryList = [...data]
      this.summaryName =
        this.summaryList.length > 1
          ? this.summaryList[0].name +
          this.$t('等') +
          this.summaryList.length +
          this.$t('人')
          : this.summaryList[0].name
      this.displayDepartmentList = displayData.department
      this.displayStaffList = displayData.staff
      this.totalInfo = total
      this.showInsider = false
    },
    confirmOtherStaff(data) {
      this.otherStaffData = [...data]
      this.showOtherStaff = false
    },
    toInform() {
      this.showInsider = false
      this.showOtherStaff = false
      this.showRelation = false
    },
    confirmOutsider() {
      if (!this.emailTest()) {
        Toast.fail(this.$t('邮箱输入错误'))
        this.outsiderName = ''
        this.outsiderEmail = ''
        return
      }
      this.outsiderList.unshift({
        name: this.outsiderName,
        email: this.outsiderEmail,
      })
      this.outsiderName = ''
      this.outsiderEmail = ''
    },
    emailTest() {
      return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
        this.outsiderEmail
      )
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.phoneMobile)
    },
    showFiled(date) {
      this.url = date.url
      var suffix = ''
      var result = ''
      try {
        var name = date.name.split('.')
        suffix = name[name.length - 1]
      } catch (err) {
        suffix = ''
      }
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'image'
        this.showImg = true
        this.isShowFiled = false
        this.imagesUrl = [date.url]
        return
      }
      // 匹配 文档
      var excelist = ['xls', 'xlsx', 'ppt', 'pptx']
      result = excelist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'text'
        this.showImg = false
        this.url =
          'https://view.officeapps.live.com/op/view.aspx?src=' + date.url
        this.isShowFiled = true
        return
      }
      // 匹配 pdf
      // var pdflist = ['pdf']
      // result = pdflist.some(function (item) {
      //   return item == suffix
      // })
      if (result) {
        this.filedType = 'pdf'
        this.showImg = false
        this.isShowFiled = true
        return
      }
      // 匹配 视频
      var videolist = ['mp4', 'mp3', 'mkv', 'wav', 'MP3', 'MP4']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        this.filedType = 'video'
        this.showImg = false
        this.playerOptions.sources = [
          {
            type: '',
            src: date.url,
          },
        ]

        this.isShowFiled = true
        return
      }
      Dialog.confirm({
        message: this.$t('暂不支持该格式文档预览'),
        messageAlign: 'center',
        cancelButtonText: this.$t('取消'),
        confirmButtonText: this.$t('确定'),
        confirmButtonColor: '#009BFF',
        cancelButtonColor: '#009BFF',
        allowHtml: true,
      })
        .then(() => { })
        .catch(() => { })
      this.isShowFiled = false
    },
  },
  created() {
    this.isVideoconferencing = localStorage.getItem('isVideoconferencing')
    this.user = JSON.parse(localStorage.getItem('user'))
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
    if (
      window.injectData &&
      window.injectData.source == 'NewWorkApp' &&
      window.injectData.meetingData
    ) {
      const meetingDatas = window.injectData.meetingData
      this.mettingData = meetingDatas
      this.mettingRoomName = meetingDatas.meetingRoomName
      this.relationMeeting = meetingDatas.relationMeetingId
        ? {
          appointmentTopic: meetingDatas.relationAppointmentTopic,
          id: meetingDatas.relationMeetingId,
        }
        : {}
      this.themeName = meetingDatas.appointmentTopic
      this.mettingContent = meetingDatas.meetingRecord
      this.parameterDate = dayjs(
        meetingDatas.appointmentEndTime,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD')
      this.originDate = dayjs(
        meetingDatas.appointmentEndTime,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD HH:mm:ss')
      this.meetingLevel = meetingDatas.meetingLevel
      this.openMeetingService = meetingDatas.openMeetingService
    } else {
      this.$route.params.ifOnline &&
        (this.ifOnline = this.$route.params.ifOnline)
      this.ifAgain = this.$route.params.ifAgain
      this.mettingData = this.$route.params.mettingData
      this.mettingRoomName =
        (this.mettingData &&
          this.mettingData.meetingRoomDto &&
          this.mettingData.meetingRoomDto.name) ||
        this.$t('线上')

      this.relationMeeting = this.mettingData.relationMeetingId
        ? {
          appointmentTopic: this.mettingData.relationAppointmentTopic,
          id: this.mettingData.relationMeetingId,
        }
        : {}
      this.themeName =
        (this.mettingData && this.mettingData.appointmentTopic) || ''
      this.mettingContent =
        (this.mettingData && this.mettingData.meetingRecord) || ''
      this.parameterDate = dayjs(
        this.mettingData.appointmentEndTime,
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD')
      this.originDate = this.$route.params.originDate
      this.meetingLevel =
        (this.mettingData && this.mettingData.meetingLevel) || 0
      this.openMeetingService =
        this.mettingData && this.mettingData.openMeetingService
    }
    this.getUserList(this.mettingData.id)
    this.getTemplateList()
    this.getMeetingTimeRange(this.user.companyId)
    this.getMeetingRoomInformation(this.user.companyId)
    this.getRelationMetting(this.user)
    this.getALLInfo(this.mettingData.meetingRoomId, this.$route.params.ifOnline)
    if (!this.ifOnline) {
      this.getAppointmentList(
        this.user.companyId,
        this.parameterDate,
        this.mettingData.meetingRoomId
      )
    }
    this.defaultDate = new Date(
      this.$route.params.mettingData.appointmentStartTime
    )
    this.isDate = new Date(this.$route.params.mettingData.appointmentStartTime)
  },
}
</script>
<style lang="less" scoped>
.mettingInfor {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;

  .metting-association {
    height: 80px;
    border-bottom: 1px solid #ececec;
    padding: 18px 16px 9px 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .metting-association-right {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      height: 24px;

      .metting-association-title {
        display: flex;
        align-items: flex-end;

        .metting-association-titel-big {
          font-weight: 600;
          font-size: 20px;
          color: #202020;
          margin-right: 7px;
        }

        .metting-association-titel-small {
          font-size: 12px;
          color: #aaaaab;
          margin-right: 7px;
          margin-bottom: 1px;
        }
      }

      img {
        height: 16px;
      }
    }

    .metting-association-name {
      font-size: 16px;
      color: #009cff;
      line-height: 24px;
      width: 190px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }

  .metting-theme {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 13px 16px;
    border-bottom: 1px solid #ececec;

    .metting-theme-title {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      line-height: 24px;

      .metting-theme-icon {
        color: #ff3b30;
        font-size: 20px;
        font-weight: 600;
      }

      .metting-theme-name {
        font-weight: 600;
        font-size: 20px;
        color: #202020;
      }
    }

    /deep/.van-cell {
      padding: 0;
    }

    /deep/.van-field__control {
      font-size: 16px;
      color: #333333;
    }
  }

  .metting-room {
    height: 56px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;

    .metting-room-left {
      display: flex;
      align-items: center;

      span {
        margin-left: 11px;
        color: #333333;
        font-size: 16px;
      }
    }

    img {
      height: 16px;
    }

    .meeting-invite {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .text {
        flex: 1;
        font-weight: 600;
        font-size: 20px;
        color: #202020;
      }

      img {
        height: 20px;
        width: 20px;
      }
    }

    .meeting-invite-name {
      color: #009bff;
    }
  }

  .informTime {
    // margin-top: 12px;
    height: 116px;
    padding: 0px 16px;

    .informTime-top {
      display: flex;
      align-items: center;
      height: 69px;
      border-bottom: 1px solid #ededed;
      justify-content: space-between;
      font-size: 14px;

      img {
        height: 45px;
      }

      .totalTime {
        height: 100%;
        width: 80px;
        display: flex;
        padding-left: 15px;
        align-items: center;
        border-left: 1px solid #ededed;
        text-align: center;

        .allTime {
          color: #009bff;
        }
      }
    }

    .informTime-bottom {
      display: flex;
      align-items: center;
      height: 47px;
      border-bottom: 1px solid #ececec;

      img {
        height: 20px;
        margin-right: 8px;
      }
    }
  }

  .encryption {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
    padding: 0 23px 0 16px;
    border-bottom: 1px solid #ececec;
  }

  .encryptionDing {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
    padding: 0 23px 0 16px;
    border-bottom: 1px solid #ececec;
    background-color: #f5f5f5;
  }

  .encryption-text {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }

  .encryption-textDing {
    font-size: 16px;
    font-weight: 400;
    color: #c0c0c0;
    line-height: 24px;
  }

  .metting-content {
    // margin-top: 12px;
    padding: 14px 16px;
    font-size: 16px;
    border-bottom: 1px solid #ececec;

    .content-top {
      font-weight: 600;
      font-size: 20px;
      color: #202020;
      // margin-bottom: 8px;
    }

    /deep/.van-cell {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .metting-people {
    height: 264px;
    padding: 0px 12px;

    // margin-top: 12px;
    .metting-inside-people,
    .metting-outside-people {
      border-bottom: 1px solid #ececec;
      font-size: 16px;
      line-height: 24px;

      span {
        color: #333333;
      }

      p {
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        height: 104px;

        .metting-outsider-name {
          color: #999999;
          display: block;
          min-width: 64px;
          padding-right: 5px;
        }

        color: #999999;
        margin-top: 8px;
        margin-right: 16px;
      }
    }

    .metting-inside-people {
      height: 152px;
      padding-top: 16px;
      overflow: hidden;

      p {
        color: #333333;
        margin-right: 0;
      }
    }

    .metting-outside-people {
      border: none;
      overflow: hidden;
      height: 110px;

      .outside-people-box {
        padding-top: 8px;
        height: 80px;
        overflow: auto;

        p {
          height: 24px;
        }
      }
    }
  }

  .metting-sign {
    padding: 16px 16px 12px;
    // margin-top: 12px;
    font-size: 16px;
    line-height: 24px;

    span {
      color: #333333;
    }

    p {
      color: #999999;
      margin-top: 8px;
    }
  }

  .button {
    width: 350px;
    height: 44px;
    font-size: 16px;
    color: #ffffff;
    margin: 16px auto 0px;
  }
}

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
}

.timeListAll {
  padding-left: 16px;
  padding-top: 5px;
  font-size: 16px;
  height: 52px;
  width: 375px;
  line-height: 51px;
}

.timeList {
  position: relative;
  border-bottom: 1px solid #ececec;
  height: 424px;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    flex: 1;
    display: block;
    border-top: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    background: #009bff;
  }
}

/deep/.date-border {
  color: #009bff;
}

.confereeBox {
  // margin-bottom: 12px;
  // margin-top: 12px;
  border-bottom: 1px solid #ececec;

  .confereeBox-top {
    padding: 17px 16px;
    // height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      flex: 1;
      font-weight: 600;
      font-size: 20px;
      color: #202020;
    }

    img {
      height: 20px;
    }
  }

  .confereeBox-bottom {
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    min-height: 100px;
    overflow: auto;
    background: #fefffe;
  }

  .outsiderWrap {
    min-height: 100px;
    overflow: auto;
    background: #ffffff;
  }

  .outsiderBox {
    margin: 10px 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    background: #f4f4f4;

    .outsiderMsg {
      display: flex;
      font-size: 14px;
      align-items: center;
      background: #f4f4f4;
      border-radius: 2px;
      // border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .outsiderName {
      height: 40px;
      width: 96px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .outsiderEMail {
      padding-left: 23px;
      width: 221px;
    }

    .outsiderDel {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f4f4f4;
      width: 40px;

      img {
        height: 8px;
        width: 8px;
      }
    }
  }
}

.themeCade {
  // margin-top: 12px;
  font-size: 16px;
  padding: 14px 0 14px 16px;
  border-bottom: 1px #ededed solid;

  .title {
    font-weight: 600;
    font-size: 20px;
    color: #202020;
    margin-bottom: 8px;
  }

  .filedList {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    flex-wrap: wrap;
    color: #1377ec;

    div {
      height: 47px;
      line-height: 47px;
    }
  }
}

.metting-summary {
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;

  .text {
    flex: 1;
    font-weight: 600;
    font-size: 20px;
    color: #202020;
  }

  .metting-summary-left {
    display: flex;
    align-items: center;

    .meeting-summary-name {
      color: #009bff;
      margin-right: 3px;
    }

    img {
      height: 20px;
      width: 20px;
    }
  }
}

// .hasBorder {
//   .van-field__label {
//     width: 25%;
//     text-align: center;
//   }
//   .van-cell__value {
//     border: 1px #dcdcdc solid !important;
//     padding: 0 8px;
//     width: 60%;
//   }
// }
.getMargin {
  margin-bottom: 8px;
}

.van-field__control {
  font-size: 16px;
}

.van-dialog {
  border-radius: 4px !important;
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  .outsider-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 16px 0px 8px;
  }

  .van-field__label {
    width: unset;
    line-height: 36px;
    font-size: 14px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.content-bottom {
  font-size: 16px;
}

.noSummary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.tencent-info {
  margin-top: 10px;
}

.tencent-text {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}

.offLineTitle {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.offLineTitlText {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.offLineTitlClose {
  position: absolute;
  top: 12px;
  right: 20px;
}

.metting-phone {
  width: 100%;
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
}

.phoneText {
  width: 70px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1e2329;
}

.phone-input {
  border-width: 0;
}

.metting-level {
  height: 83px;
  border-bottom: 1px solid #ececec;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.metting-service {
  height: 60px;
  border-bottom: 1px solid #ececec;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.levelText {
  width: 95px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1e2329;
  margin-bottom: 10px;
}

.serviceText {
  width: 80px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1e2329;
  line-height: 20px;
}
</style>
